var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "menu",
      class: {
        glossaryIsShown: _vm.$root.states.glossaryIsShown,
        menuIsActive: _vm.$root.states.menuIsActive,
        searchResultsAreShown: _vm.$root.states.searchResultsAreShown,
        searchResultsReferrer: _vm.$root.states.searchResultsReferrer,
        viewIsScrolled: _vm.$root.states.viewIsScrolled,
        hasVideo: _vm.$root.states.articleHasVideo
      }
    },
    [
      _c("div", { staticClass: "wrap" }, [
        _c(
          "div",
          { staticClass: "wrap-body" },
          [
            _c(
              "div",
              { staticClass: "menu-header" },
              [
                _c("router-link", { attrs: { to: "/" } }, [
                  _c("div", { staticClass: "menu-header-brand" }, [
                    _vm._v(
                      "\n                        #nochvielvor\n                    "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "menu-header-navigation-back",
                    on: { click: _vm.navigateBack }
                  },
                  [
                    _c("span", {
                      staticClass: "menu-header-navigation-back-bar"
                    }),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "menu-header-navigation-back-bar"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "menu-header-toggle",
                    on: { click: _vm.toggleContext }
                  },
                  [
                    _c("span", { staticClass: "header-menu-toggle-bar" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "header-menu-toggle-bar" })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchIsActive === false,
                    expression: "searchIsActive === false"
                  }
                ],
                staticClass: "menu-items-container"
              },
              [
                _c(
                  "nav",
                  { staticClass: "menu-items" },
                  [
                    _vm._l(_vm.menus["main-menu-primary"], function(menuItem) {
                      return [
                        menuItem._childMenuItems.length === 0
                          ? [
                              _c(
                                "router-link",
                                {
                                  staticClass: "menu-item",
                                  attrs: {
                                    to: _vm.wpApi.stripBaseUrl(menuItem["url"])
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.wpApi.decodeHtmlEntityAmpersand(
                                          menuItem["title"]
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        menuItem._childMenuItems.length > 0
                          ? [
                              _c("div", { staticClass: "menu-item-group" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "menu-item position-relative",
                                    on: {
                                      click: function($event) {
                                        return _vm.toggleMenuItemGroup(menuItem)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.wpApi.decodeHtmlEntityAmpersand(
                                            menuItem["title"]
                                          )
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "child-menu-item-group-wrapper"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.menuItemGroupStates[
                                                menuItem["ID"]
                                              ] === true,
                                            expression:
                                              "menuItemGroupStates[menuItem['ID']] === true"
                                          }
                                        ],
                                        staticClass:
                                          "child-menu-item-group clearfix"
                                      },
                                      _vm._l(menuItem._childMenuItems, function(
                                        childMenuItem
                                      ) {
                                        return _c(
                                          "router-link",
                                          {
                                            key: childMenuItem["ID"],
                                            staticClass:
                                              "child-menu-item btn btn-white-pink-black-white",
                                            attrs: {
                                              to: _vm.wpApi.stripBaseUrl(
                                                childMenuItem["url"]
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.wpApi.decodeHtmlEntityAmpersand(
                                                    childMenuItem["title"]
                                                  )
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        )
                                      }),
                                      1
                                    )
                                  ]
                                )
                              ])
                            ]
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchIsActive,
                    expression: "searchIsActive"
                  }
                ],
                staticClass: "menu-search-container",
                style: { fontSize: _vm.searchInputFontSizePx + "px" }
              },
              [
                _c("div", { staticClass: "menu-search" }, [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.search.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "menu-search-input-clone",
                          style: { fontSize: _vm.searchInputFontSizePx + "px" }
                        },
                        [_vm._v(_vm._s(_vm.$root.states.searchValue))]
                      ),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "menu-search-input-clone-icon"
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$root.states.searchValue,
                            expression: "$root.states.searchValue"
                          }
                        ],
                        staticClass: "menu-search-input",
                        style: { fontSize: _vm.searchInputFontSizePx + "px" },
                        attrs: { placeholder: "Suche", type: "search" },
                        domProps: { value: _vm.$root.states.searchValue },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.$root.states,
                              "searchValue",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.$root.states.searchValue.length,
                            expression: "$root.states.searchValue.length"
                          }
                        ],
                        staticClass: "menu-search-input-icon",
                        on: { click: _vm.search }
                      })
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("tags", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.searchIsActive,
                  expression: "searchIsActive"
                }
              ],
              staticClass: "isScrolledIntoView",
              attrs: { "article-primary-keyword-data": _vm.tags }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "wrap-footer" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.searchIsActive === false,
                  expression: "searchIsActive === false"
                }
              ],
              staticClass: "menu-addon-items"
            },
            [
              _c("div", { staticClass: "menu-addon-icons" }, [
                _c(
                  "div",
                  {
                    staticClass: "menu-addon-icon",
                    on: {
                      click: function($event) {
                        _vm.searchIsActive = !_vm.searchIsActive
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: { src: "/img/ic_search_000000.svg", alt: "Suche" }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.menus["main-menu-secondary"], function(menuItem) {
                return _c(
                  "router-link",
                  {
                    key: menuItem["ID"],
                    staticClass: "menu-addon-item",
                    attrs: { to: _vm.wpApi.stripBaseUrl(menuItem["url"]) }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.wpApi.decodeHtmlEntityAmpersand(menuItem["title"])
                        ) +
                        "\n                "
                    )
                  ]
                )
              })
            ],
            2
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46987f75", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46987f75","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/AppMenu.vue
// module id = 544
// module chunks = 0